
import errorParseNetwork from '~/helpers/errorParseNetwork';

export default {
  name: 'CharacteristicsList',
  data() {
    return {
      seriesLink: '',
    };
  },

  props: {
    characteristics: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    getCharacteristics() {
      const list = [];
      const char = this.characteristics;

      char.forEach((t) => {
        t.characteristics
          .filter((t) => Boolean(t.id !== 56))
          .forEach((d) => {
            const charString = [];

            if (d.showInProduct) {
              d?.values.forEach((item) => {
                charString.push({
                  value: item?.value || '',
                  slug: item?.slug || '',
                });
              });

              list.push({
                unit: d.unit,
                id: d.id,
                name: d.name,
                value: charString,

              });
            }
          });
      });
      return list;
    },
  },

  methods: {
    async getSeriesLink() {
      let seriesName = '';

      this.getCharacteristics.forEach((ser) => {
        if (ser.name === 'Серия') {
          seriesName = ser.value?.[0]?.value;
        }
      });
      if (!seriesName) {
        return;
      }
      const res = await this.$api.agent.transport
        .get(`gost/search-by-name?query=${seriesName}`)
        .then((res) => res.data)
        .catch((err) => ({
          error: errorParseNetwork(err),
        }));

      if (res?.model?.slug) {
        this.seriesLink = `/normdocument/${res?.model?.slug}`;
      }
    },
  },
  created() {
    this.$nextTick(async () => {
      await this.getSeriesLink();
    });
  },
};
